// Building blocks - react, redux, redux form, translations
import React, { Component } from "react";
import { connect } from "react-redux";
import { getFormValues, reduxForm } from "redux-form";
import { Translate } from "react-redux-i18n";

// React Spectrum Components
import { Grid, GridColumn, GridRow } from "@react/react-spectrum/Grid";
import Well from "@react/react-spectrum/Well";
import Button from "@react/react-spectrum/Button";
import Heading from "@react/react-spectrum/Heading";
import Wait from "@react/react-spectrum/Wait";
import Rule from "@react/react-spectrum/Rule";

// Access project files
import DataSection from "../../comps/DataSection/DataSection";
import { toastPartnerApiFailure } from "../../comps/errorToast";
import formFields from "../config/formFieldsEducation";
import "../specialization.css";
import Attachment from "../content/Common/Attachment";
import Finish from "../content/Common/Finish";
import {
  openManageProfile,
  onSubmitClick,
} from "../content/Common/buttonActions";
import { RegionEducationMapping } from "../config/countryEducationMapping";
import UnauthorizedError from "./Common/Error/UnauthorizedError";
import { isRestrictedSanctionCountry } from "../../utils/restrictedSanctionCountry";
// TODO(sanctions-ru-by): RU/BY banner + disabled Submit/Choose File — SANCTIONS_RU_BY_VALIDATION_ENABLED
import RestrictedCountryBanner from "../../components/RestrictedCountryBanner";

let g_countryBasedLang;
class Education extends Component {
  constructor() {
    super();
    window.scrollTo(0, 0);
    this.state = {
      sectionValidation: {},
      countryBasedLang: "",
      questions: [],
      isLoaded: false,
      error: {},
    };
  }

  updateError = (error) => {
    this.setState({ error: error });
  };

  componentDidMount() {
    this.updateValidation("attachment", false);
    this.setBasicAccountInfoFromResponse(this.props.partnerData);
    // setPartnerData is called inside fetchAnswers so that initialized can be called at once to load all data.
    // Making another call to fetch questions and answers. Question Id is required in submit so this call is mandatory.
    this.fetchAnswers();
  }

  setBasicAccountInfoFromResponse = (response) => {
    // Set basic info from Account
    for (const key in RegionEducationMapping) {
      if (
        RegionEducationMapping[key].countryList.includes(
          response?.partnerInfo?.billingCountry?.toUpperCase(),
        )
      ) {
        this.setState({
          countryBasedLang: key,
          questions: formFields.questions[key],
          level: response?.partnerInfo?.level,
        });
        this.g_countryBasedLang = key;
        break;
      }
    }
  };

  setPartnerData = (response, returnValue = false) => {
    if (!response?.error) {
      // If Submitted then show submitted in review page
      if (
        response?.specialization &&
        response?.specialization?.status == "Submitted"
      ) {
        this.setState({ status: "Submitted" });
      } else {
        // If Approved then pre-populate contacts and attachment
        if (
          response?.specialization &&
          response?.specialization?.status == "Approved"
        ) {
          let dataToInitialize = {},
            currentValue = 0,
            lastCount = -1;
          // Pre-populate contacts
          while (currentValue > lastCount) {
            ++lastCount;
            if (
              "specializationContact" + currentValue in
              response?.specialization
            ) {
              "firstName" in
              response.specialization["specializationContact" + currentValue]
                ? (dataToInitialize["firstName" + currentValue] =
                    response.specialization[
                      "specializationContact" + currentValue
                    ].firstName)
                : "";
              dataToInitialize["lastName" + currentValue] =
                response.specialization[
                  "specializationContact" + currentValue
                ].lastName;
              if (
                "email" in
                response.specialization["specializationContact" + currentValue]
              ) {
                dataToInitialize["email" + currentValue] =
                  response.specialization[
                    "specializationContact" + currentValue
                  ].email;
                dataToInitialize["oldEmail" + currentValue] =
                  response.specialization[
                    "specializationContact" + currentValue
                  ].email;
              }
              "id" in
              response.specialization["specializationContact" + currentValue]
                ? (dataToInitialize["id" + currentValue] =
                    response.specialization[
                      "specializationContact" + currentValue
                    ].id)
                : "";
              ++currentValue;
            }
          }
          if (returnValue) return dataToInitialize;
          else this.props.initialize(dataToInitialize);
        }
      }
    } else {
      this.setState({ isError: true });
    }
  };

  fetchAnswers = () => {
    this.props.connector.fetchAnswers(
      this.onFetchAnswers,
      this.props.partnerData.partnerInfo.accountId,
      this.props.formName,
    );
  };

  onFetchAnswers = (response) => {
    if (response?.isError) {
      toastPartnerApiFailure(response);
    } else {
      let mapQues = {};
      for (let index in response.questionsList) {
        mapQues[response.questionsList[index].id] =
          response?.questionsList[index];
      }
      this.setState({ mapQues: mapQues });
      this.setAnswer(response, mapQues);
    }
    this.setState({ isLoaded: true });
  };

  updateValidation = (name, value) => {
    let sectionValidation = this.state.sectionValidation;
    sectionValidation[name] = value;
    this.setState({ sectionValidation: sectionValidation });
  };

  render() {
    if (!this.state.countryBasedLang) {
      return <UnauthorizedError />;
    }
    if (!this.props.isFinal) {
      const formName = "specialization";
      const isSanctionRestricted = isRestrictedSanctionCountry(
        this.props.partnerData?.partnerInfo?.billingCountry,
      );
      this.props.onValidateChange(
        Object.values(this.state.sectionValidation).every(Boolean),
      );
      let sections = [];
      if (
        RegionEducationMapping[this.state.countryBasedLang].showQuestionnaire
      ) {
        for (let i = 0; i < this.state.questions.length; i++) {
          if (this.state.questions[i].addNewLineAbove) {
            sections.push(<br key={"questions_addNewLineAbove_ques" + i} />);
          }
          if (Array.isArray(this.state.questions[i])) {
            let totalCols = this.state.questions[i].length;
            let column = [];
            for (let col = 0; col < this.state.questions[i].length; col++) {
              column.push(
                <GridColumn
                  size={[12, 12 / totalCols, 12 / totalCols, 12 / totalCols]}
                  key={"questionsList" + i + "_" + col}
                >
                  <DataSection
                    formStates={this.props.formStates}
                    form={formName}
                    field={
                      Array.isArray(this.state.questions[i][col])
                        ? this.state.questions[i][col]
                        : new Array(this.state.questions[i][col])
                    }
                    sectionName={"section_q_" + i + "_" + col}
                    updateValidation={this.updateValidation}
                  />
                </GridColumn>,
              );
            }
            sections.push(
              <GridRow style={{ margin: "1px" }} key={"questionsList" + i}>
                {column}
              </GridRow>,
            );
          } else {
            {
              Boolean(this.state.error && this.state.error["section_q_" + i])
                ? sections.push(
                    <GridRow style={{ margin: "1px" }}>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <span style={{ color: "red", fontStyle: "bold" }}>
                          {this.state.error["section_q_" + i]}
                        </span>
                      </GridColumn>
                    </GridRow>,
                  )
                : "";
            }
            sections.push(
              <DataSection
                formStates={this.props.formStates}
                form={formName}
                field={new Array(this.state.questions[i])}
                sectionName={"section_q_" + i}
                updateValidation={this.updateValidation}
                key={"nonArrayQuestion" + i}
              />,
            );
          }
          if (this.state.questions[i].addNewLineBelow) {
            sections.push(<br key={"questions_addNewLineBelow_ques" + i} />);
          }
        }
      }
      return (
        <div>
          {this.state.isLoaded ? (
            <div>
              <div className="page-head">
                <Heading
                  style={{
                    paddingLeft: "2%",
                    color: "white",
                    fontSize: "22px",
                    fontWeight: "bold",
                  }}
                  variant="pageTitle"
                >
                  EDUCATION FORM
                </Heading>
              </div>
              <div className="page-banner">
                <div className="center">
                  <Heading
                    variant="pageTitle"
                    size="28px"
                    style={{ fontWeight: "bold", color: "#323232" }}
                  >
                    <Translate value="specialization.SplznEduHeader" />
                  </Heading>
                  <GridRow>
                    <GridColumn size={[12, 3, 3, 3]}></GridColumn>
                    <GridColumn size={[12, 6, 6, 6]}>
                      <Heading
                        variant="subtitle2"
                        style={{ color: "rgb(112, 112, 112)" }}
                      >
                        <Translate value="specialization.SplznWelcomeEduNote1" />
                        <Translate value="specialization.SplznWelcomeEduNote2" />
                      </Heading>
                    </GridColumn>
                    <GridColumn size={[12, 3, 3, 3]}></GridColumn>
                  </GridRow>
                </div>
              </div>
              <Grid>
                <RestrictedCountryBanner visible={isSanctionRestricted} />
                <GridRow>
                  <GridColumn size={[12, 10, 8, 8]} offsetSize={[0, 1, 2, 2]}>
                    <GridRow>
                      <GridColumn>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          <Translate value="specialization.SplznCriteriaHeader" />
                        </Heading>
                      </GridColumn>
                    </GridRow>
                    <Well className="well-white">
                      <GridRow>
                        <GridColumn size={[12, 12, 12, 12]}>
                          <ul>
                            {RegionEducationMapping[
                              this.state.countryBasedLang
                            ].criterias.map(function (value, index) {
                              return (
                                <li key={"specializationCriteria" + index}>
                                  {value}
                                </li>
                              );
                            })}
                          </ul>
                        </GridColumn>
                      </GridRow>
                    </Well>
                    <br />

                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          <Translate value="specialization.SplznSpecialistHeader" />
                        </Heading>
                        <Rule className="rule" variant="medium" />
                        <p style={{ margin: "8px 15px" }}>
                          {RegionEducationMapping[
                            this.state.countryBasedLang
                          ].contactHead.map(function (value, index) {
                            return (
                              <Translate
                                value={"specialization." + value}
                                key={"specialization." + value + "_" + index}
                              />
                            );
                          })}
                        </p>
                      </GridColumn>
                    </GridRow>
                    {Boolean(this.state.error.contact) ? (
                      <GridRow style={{ margin: "1px" }}>
                        <GridColumn size={[12, 12, 12, 12]}>
                          <span style={{ color: "red", fontStyle: "bold" }}>
                            {this.state.error.contact}
                          </span>
                        </GridColumn>
                      </GridRow>
                    ) : (
                      ""
                    )}
                    <GridRow style={{ margin: "1px" }}>
                      <GridColumn size={[12, 6, 6, 6]}>
                        <div style={{ paddingBottom: "1%", paddingTop: "1%" }}>
                          <span>Contact 1</span>
                        </div>
                        <DataSection
                          formStates={this.props.formStates}
                          form={formName}
                          field={formFields.section1}
                          sectionName="section1"
                          updateValidation={this.updateValidation}
                        />
                      </GridColumn>
                      {RegionEducationMapping[this.state.countryBasedLang]
                        .noOfContacts == 2 ? (
                        <GridColumn size={[12, 6, 6, 6]}>
                          <div
                            style={{ paddingBottom: "1%", paddingTop: "1%" }}
                          >
                            <span>Contact 2</span>
                          </div>
                          {this.state.level == "Certified" &&
                          this.props.formStates &&
                          !(
                            this.props.formStates.firstName1 ||
                            this.props.formStates.lastName1 ||
                            this.props.formStates.email1
                          ) ? (
                            <DataSection
                              formStates={this.props.formStates}
                              form={formName}
                              field={formFields.section2.notRequiredFields}
                              sectionName="section2"
                              updateValidation={this.updateValidation}
                            />
                          ) : (
                            <DataSection
                              formStates={this.props.formStates}
                              form={formName}
                              field={formFields.section2.requiredFields}
                              sectionName="section2"
                              updateValidation={this.updateValidation}
                            />
                          )}
                        </GridColumn>
                      ) : (
                        ""
                      )}
                    </GridRow>
                    <br />

                    {RegionEducationMapping[this.state.countryBasedLang]
                      .showQuestionnaire ? (
                      <>
                        <GridRow>
                          <GridColumn size={[12, 12, 12, 12]}>
                            <Heading
                              className="section-heading-sp"
                              variant="subtitle1"
                            >
                              <Translate value="specialization.SplznQuestionnaireHeader" />
                            </Heading>
                            <Rule className="rule" variant="small" />
                          </GridColumn>
                        </GridRow>
                        {sections}
                        <br />
                      </>
                    ) : (
                      ""
                    )}

                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          <Translate value="specialization.SplznAttachmentHeader" />
                        </Heading>
                        <Rule className="rule" variant="small" />
                      </GridColumn>
                    </GridRow>
                    {Boolean(this.state.error.attachment) ? (
                      <GridRow style={{ margin: "1px" }}>
                        <GridColumn size={[12, 12, 12, 12]}>
                          <span style={{ color: "red", fontStyle: "bold" }}>
                            {this.state.error.attachment}
                          </span>
                        </GridColumn>
                      </GridRow>
                    ) : (
                      ""
                    )}
                    <GridRow style={{ margin: "1px" }}>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <span>
                          <Translate value="specialization.SplznAttachmentBody" />
                        </span>
                      </GridColumn>
                    </GridRow>
                    <GridRow style={{ margin: "1px" }}>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <span>
                          <Translate value="specialization.SplznAttachmentBody2" />
                        </span>
                      </GridColumn>
                    </GridRow>
                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <ul>
                          {RegionEducationMapping[
                            this.state.countryBasedLang
                          ].attachmentPointers.map(function (value, index) {
                            return (
                              <li key={"attchPointer" + index}>{value}</li>
                            );
                          })}
                        </ul>
                      </GridColumn>
                    </GridRow>
                    <GridRow style={{ margin: "1px" }}>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <span>
                          <Translate value="specialization.SplznAttachmentNote" />
                        </span>
                      </GridColumn>
                    </GridRow>
                    <Attachment
                      {...this.props}
                      disabled={isSanctionRestricted}
                      updateValidation={this.updateValidation}
                    />
                    <br />
                    <br />

                    <GridRow>
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Heading
                          className="section-heading-sp"
                          variant="subtitle1"
                        >
                          <Translate value="specialization.SplznTermsConditionsHeader" />
                        </Heading>
                      </GridColumn>
                    </GridRow>
                    <Well className="well">
                      <GridRow style={{ padding: "5px 5px 5px 5px" }}>
                        <GridColumn size={[12, 12, 12, 12]}>
                          {Boolean(this.state.error.section10) ? (
                            <GridRow>
                              <GridColumn size={[12, 12, 12, 12]}>
                                <span
                                  style={{ color: "red", fontStyle: "bold" }}
                                >
                                  {this.state.error.section10}
                                </span>
                              </GridColumn>
                            </GridRow>
                          ) : (
                            ""
                          )}
                          {this.state.countryBasedLang == "en_us" ? (
                            <>
                              <GridRow>
                                <GridColumn size={[12, 12, 12, 12]}>
                                  If Reseller’s application for the Education
                                  Specialization is accepted by Adobe, Reseller
                                  represents and warrants that:
                                </GridColumn>
                              </GridRow>
                              <GridRow>
                                <GridColumn size={[12, 12, 12, 12]}>
                                  <ol>
                                    <li>
                                      All information provided by Reseller to
                                      Adobe as part of the Education
                                      Specialization application is true,
                                      correct, complete and accurate in every
                                      respect and is not misleading or deceptive
                                      (including by omission), and Reseller will
                                      update or correct (via email to Adobe at
                                      integrity@adobe.com ), in a timely manner,
                                      any information that it previously
                                      submitted that it knows has changed or is
                                      no longer true, correct, complete and
                                      accurate; and
                                    </li>
                                    <li>
                                      Reseller will abide by the terms of the
                                      Agreement and the Partner Connection
                                      Program Guide.
                                    </li>
                                  </ol>
                                </GridColumn>
                              </GridRow>
                              <GridRow>
                                <GridColumn size={[12, 12, 12, 12]}>
                                  Unless otherwise expressly defined in this
                                  Addendum, capitalized terms used in this
                                  Addendum shall have the same meaning set forth
                                  in the Agreement.
                                </GridColumn>
                              </GridRow>
                            </>
                          ) : (
                            <GridRow>
                              <GridColumn size={[12, 12, 12, 12]}>
                                {
                                  RegionEducationMapping[
                                    this.state.countryBasedLang
                                  ].terms
                                }
                              </GridColumn>
                            </GridRow>
                          )}
                          <GridRow>
                            <GridColumn size={[12, 1, 1, 1]}>
                              <DataSection
                                formStates={this.props.formStates}
                                form={formName}
                                field={formFields.section10}
                                sectionName="section10"
                                updateValidation={this.updateValidation}
                              />
                            </GridColumn>
                            <GridColumn size={[12, 11, 11, 11]}>
                              <div style={{ paddingTop: "0.5%" }}>
                                <span>
                                  I HAVE READ, UNDERSTOOD, AND AGREED TO COMPLY
                                  WITH THE TERMS AND CONDITIONS INDICATED
                                  HEREIN, AND I REPRESENT AND WARRANT THAT I AM
                                  AUTHORIZED TO BIND THE RESELLER.
                                </span>
                              </div>
                            </GridColumn>
                          </GridRow>
                        </GridColumn>
                      </GridRow>
                    </Well>
                    <br />
                    <br />

                    <GridRow
                      style={{ margin: "1px", paddingTop: "10px" }}
                      className="center"
                    >
                      <GridColumn size={[12, 12, 12, 12]}>
                        <Button
                          onClick={() => {
                            openManageProfile();
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="cta"
                          disabled={isSanctionRestricted}
                          onClick={() => {
                            onSubmitClick(
                              this.props,
                              this.state.mapQues,
                              this.state.countryBasedLang,
                              this.updateError,
                              this.state.sectionValidation,
                            );
                          }}
                        >
                          Submit
                        </Button>
                      </GridColumn>
                    </GridRow>
                  </GridColumn>
                </GridRow>
              </Grid>
            </div>
          ) : (
            <Wait size="L" centered />
          )}
        </div>
      );
    } else {
      return <Finish />;
    }
  }

  setAnswer = (response, mapQues) => {
    let lstAnswerToSet = {};
    for (let index in response.answers) {
      let quesOrder = RegionEducationMapping[
        this.g_countryBasedLang
      ].questionNumber.indexOf(
        parseInt(mapQues[response.answers[index].questionId].questionNumber),
      );
      for (let i in RegionEducationMapping[this.g_countryBasedLang]
        .answerNameUI[quesOrder]) {
        lstAnswerToSet[
          RegionEducationMapping[this.g_countryBasedLang].answerNameUI[
            quesOrder
          ][i]
        ] =
          response.answers[index][
            RegionEducationMapping[this.g_countryBasedLang].answerNameBackend[
              quesOrder
            ][i]
          ];
      }
    }
    lstAnswerToSet = {
      ...lstAnswerToSet,
      ...this.setPartnerData(this.props.partnerData, true),
    };
    this.props.initialize(lstAnswerToSet);
  };
}

Education = reduxForm({
  form: "specialization",
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(Education);

function mapStateToProps(state) {
  return {
    formStates: getFormValues("specialization")(state),
    isValidated: state.specialization.isValidated,
    isFinal: state.specialization.isFinal,
    allFields: state.form,
  };
}

export default connect(mapStateToProps)(Education);
